<template>
  <v-row>
    <v-col cols="12" v-if="!selectedCounter">
      <v-row justify="end">
        <v-dialog
          v-model="dialog"
          width="500">
          <template v-slot:activator="{ on }">
            <v-btn 
              class="ma-2" 
              v-on="on" 
              color="success" 
              small 
              dark>
              new counter
              <v-icon right dark>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">New counter</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field label="Name*" v-model="newCounter.name" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Min value*" v-model="newCounter.min" type="number" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Max value*" v-model="newCounter.max" type="number" required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>* required</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="resetForm()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveCounter()">Save</v-btn>
            </v-card-actions>
          </v-card>          
        </v-dialog>
      </v-row>
    </v-col>
    <v-col cols="12" v-if="!selectedCounter && counters.length > 0">
      <v-simple-table>
          <template v-slot:default>
          <thead>
              <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Current</th>
              <th class="text-left">Last update</th>
              <th class="text-left">Min</th>
              <th class="text-left">Max</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="item in counters" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}</td>
              <td>{{ $moment.utc(item.lastReset).local().format('dddd D MMM YYYY HH:mm') }}</td>
              <td>{{ item.min }}</td>
              <td>{{ item.max }}</td>
              </tr>
          </tbody>
          </template>
      </v-simple-table>
    </v-col>
    <v-col cols="12" v-if="selectedCounter">
       
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SettingsCounters",
  props: ["me", "roles"],
  data() {
    return {
      counters: [],
      dialog: false,
      newCounter: {
        name: '',
        min: 0,
        max: 0
      },
      selectedCounter: null
    };
  },
  methods: {
    resetForm() {
      this.newCounter = {
        name: '',
        min: 0,
        max: 0
      };
      this.dialog = false;
    },
    saveCounter() {
      this.$http
        .post("api/counters", this.newCounter)
        .then(request => {
          if (request.status == 200) {
            this.dialog = false;
          } else {
            this.dialog = false;
          }
          this.getCounters();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "2200", e);
        });
    },
    getCounters() {
      this.counters = [];
      this.$http
        .get("api/counters")
        .then(request => {
          if (request.status == 200) {
            if (request.data) this.counters = request.data;
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "2201", e);
        });
    }
  },
  mounted() {
      this.getCounters();
  }
};
</script>